/**
 * Delegating depth strategy
 *
 * @class DelegatingStrategy
 */
export default class DelegatingStrategy {
    /**
     * @param {Array} strategies
     */
    constructor(strategies) {
        this.strategies = strategies;
    }

    /**
     * Checks if the given item fits into the drawer depth.
     *
     * @param {FigureItem} item Item to check
     * @return {boolean} True if item fits
     */
    checkItemDepth(item) {
        const strategyName = item.getParentItem().get('depthStrategy');

        if (this.strategies[strategyName]) {
            return this.strategies[strategyName].checkItemDepth(item);
        }

        throw new Error(`Unknown depth strategy ${strategyName}`);
    }
}
